import {put,takeLatest,call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    REORDER_PRODUCT_TYPES,
    REORDER_PRODUCT_TYPES_SUCCESS,
    REORDER_PRODUCT_TYPES_ERROR,
}
    from "../../../actions/menu/productTypes";

function* reOrderProductTypesSaga(action) {
    try {

        yield put({
            type: REORDER_PRODUCT_TYPES_SUCCESS,
            payload: action.payload
        });
        yield call(productTypeService.ReOrderProductTypes,action.payload)

    } catch(error) {
        yield put({
            type: REORDER_PRODUCT_TYPES_ERROR,error: error.data
        });
    }
}


export function* reOrderProductTypesSagaWatcher() {
    yield takeLatest(REORDER_PRODUCT_TYPES,reOrderProductTypesSaga);
}